import { Dictionary } from 'themes/jumbo/app/_dictionaries/type';
import enUS from 'themes/jumbo/app/_dictionaries/en.json';
import arSA from 'themes/jumbo/app/_dictionaries/ar.json';
import esES from 'themes/jumbo/app/_dictionaries/es.json';
import frFR from 'themes/jumbo/app/_dictionaries/fr.json';
import itIT from 'themes/jumbo/app/_dictionaries/it.json';
import zhCN from 'themes/jumbo/app/_dictionaries/zh.json';
// import 'server-only';

interface LocaleDictionary {
  [x: string]: Dictionary;
}

const dictionaries: LocaleDictionary = {
  'en-US': enUS,
  'ar-SA': arSA,
  'es-ES': esES,
  'fr-FR': frFR,
  'it-IT': itIT,
  'zh-CN': zhCN,
};

export const getDictionary = (locale: string) => dictionaries[locale];
